
import {
  defineComponent, ref, computed, onBeforeMount,
} from 'vue';
import DataSourceTreeSelect from '@/components/fields/DataSourceTreeSelect.vue';
import { DataSourceOption } from '@/composables/data-sources/dataSourceTree';
import { isMultiSourceShop } from '@/composables/data-sources/multiSource';
import { fetchDataSources } from '@/composables/segmentations/helpers/fetchData';
import { useStore } from '@/store';

export default defineComponent({
  name: 'GlobalDataSourceSelector',

  components: { DataSourceTreeSelect },

  setup() {
    const store = useStore();
    const sources = ref<DataSourceOption[]>([]);
    const selectedSourceIds = ref<number[]>([]);

    // Affiché seulement pour une boutique multi-sources (règle partagée).
    const multiSource = computed(() => isMultiSourceShop(sources.value));

    const allSourceIds = () => sources.value.map((s) => s.value);

    const isAllSelected = computed(() => sources.value.length > 0 && selectedSourceIds.value.length === sources.value.length);

    const persistToStore = () => {
      if (isAllSelected.value) {
        store.commit('general/setSelectedDataSources', []);
      } else {
        store.commit('general/setSelectedDataSources', [...selectedSourceIds.value]);
      }
    };

    onBeforeMount(async () => {
      sources.value = await fetchDataSources();

      // Restore selection from store (persisted via localStorage)
      const storedIds: number[] = store.getters['general/getSelectedDataSourceIds'];
      const ids = allSourceIds();

      if (storedIds && storedIds.length > 0) {
        // Filter out IDs that no longer exist (deleted/deactivated sources)
        const validIds = storedIds.filter((id) => ids.includes(id));
        if (validIds.length > 0) {
          selectedSourceIds.value = validIds;
        } else {
          // All stored IDs are invalid, reset to all
          selectedSourceIds.value = ids;
        }
      } else {
        // No stored selection = all sources
        selectedSourceIds.value = ids;
      }

      persistToStore();
    });

    // The list already applied the cascade (parent <-> stores); an empty
    // selection means every source here.
    const onSelectionChange = (ids: number[]) => {
      selectedSourceIds.value = ids.length === 0 ? allSourceIds() : ids;
      persistToStore();
    };

    const onPanelHide = () => {
      if (selectedSourceIds.value.length === 0) {
        selectedSourceIds.value = allSourceIds();
        persistToStore();
      }
    };

    return {
      sources,
      multiSource,
      selectedSourceIds,
      onSelectionChange,
      onPanelHide,
    };
  },
});
